import { createSlice } from "@reduxjs/toolkit";
import { PaymeterBalance } from "../Apis/PaymeterBalance";

export const PaymeterBalanceSlice = createSlice({
  name: "paymeterbalance",
  initialState: {
    paymeterbalance: null,
    authenticatingpaymeterbalance: false,
    authenticated: false,
    isError: false,
    errors: null
  },
  reducers: {
    clearState: (state) => {
      state.paymeterbalance = null;
      state.isError = false;
      state.authenticated = false;
      state.authenticatingpaymeterbalance = false;
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PaymeterBalance.fulfilled, (state, action) => {
      state.paymeterbalance = action.payload;
      state.authenticated = false;
      state.authenticatingpaymeterbalance = false;
      return state;
    });
    builder.addCase(PaymeterBalance.pending, (state, action) => {
      state.authenticatingpaymeterbalance = true;
      state.authenticated = true;
    });
    builder.addCase(PaymeterBalance.rejected, (state, action) => {
      state.errors = action.errors || action.payload;
      state.authenticated = false;
      state.authenticatingpaymeterbalance = false;
      state.isError = true;
      return state;
    });
  }
});

export const { clearState } = PaymeterBalanceSlice.actions;

export const PaymeterBalanceSelector = (state) => state.paymeterbalance;
